import { compose } from "recompose";

import withOnLoadFailure from "./withOnLoadFailure";
import withReportFeedbackHandler from "./withReportFeedbackHandler";

export default compose(withOnLoadFailure, withReportFeedbackHandler);
